<template>
  <div>

    <Spinner v-if="loading === true"></Spinner>

    <div
        v-if="loading === false"
        class="row"
    >
      <div class="col-md-6"/>
      <div class="col-md-6 create-button">
        <button
            id="deleteMultiple"
            type="button"
            class="btn btn-outline-primary mb-2 mr-1"
            @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
            type="button"
            class="btn btn-primary mb-2"
            data-toggle="modal"
            data-target="#createModal"
        >
          Create
        </button>
        <create @refresh="renderTable()"/>
      </div>
    </div>
    <basic-table
        v-if="loading === false"
        :columns="columns"
        :values="rows"
        @choosenObject="getEditedObject($event)"
        @deleteItems="removeItems($event)"
        @deletedMultipleIds="catchIds($event)"
    />
    <edit
        :faq="editedItem"
        @refresh="renderTable()"
    />
  </div>
</template>

<script>
import BasicTable from '../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import newsService from '@/services/newsService'
import Spinner from "@/shared/loader/Spinner";
import faqsService from "@/services/faqsService";

export default {
  components: {
    Spinner,
    Create,
    Edit,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      editedItem: '',
      columns: [

        {
          label: 'Question',
          field: 'question',
        },
        {
          label: 'Answer',
          field: 'answer',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getFaqs()
  },
  methods: {
    getFaqs() {
      this.loading = true;
      faqsService.index().then(response => {
        this.rows = response.data.data
        this.loading = false
      });
    },
    getEditedObject(obj) {
      this.editedItem = obj
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            faqsService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your file has been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.getFaqs()
                })
              }
            }).catch(error => Promise.reject(error))
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    renderTable() {
      this.getFaqs()
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

</style>
